/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Collapse, Button } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { useEffect, useRef, useState } from "react"
import DateInput from "../../../components/InputWrapper/DateInput"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import { Form } from "react-bootstrap"
import Spinner from "../../../components/Spinner"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import { 区分分類コード } from "../../../constant/enum/codes"
import {
  TKaikonZyutyuHaisyaListGetReq,
  TKaikonZyutyuHaisyaListGetReqInner,
  TKaikonZyutyuHaisyaListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"
import {
  e海コン検索日種別,
  T海コン検索日種別コード,
} from "../../../constant/enum/frontend"
import KaikonZyutyuHaisyaService from "../../../service/orderContainer/kaikonZyutyuHaisya/kaikonZyutyuHaisyaService"
import { KaikonZyutyuHaisyaListProvider } from "./KaikonZyutyuHaisyaListContext"
import KaikonZyutyuHaisyaListGrid from "./KaikonZyutyuHaisyaListGrid"
import dateUtil from "../../../ts/util/dateUtil"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import CONSTANT from "../../../constant"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import {
  T検索日ComboboxItem,
  検索日制御用配列,
} from "./KaikonZyutyuHaisyaListConstant"

type TOmitDisplay =
  | "受注部所コード"
  | "表紙分割コード"
  | "請求内訳コード"
  | "付替区分コード"
  | "車種区分コード"
  | "運行部所コード"
  | "配車状態区分コード"
  | "確認区分コード"
  | "請求額確認区分コード"
  | "傭車会社あり対象フラグ"
  | "表示順区分コード"
  | "オーダー備考"
  | "オーダー内容"
  | "オーダー指定時間"

type T表示用検索条件<T extends T海コン検索日種別コード> = Omit<
  TKaikonZyutyuHaisyaListGetReq<T>,
  TOmitDisplay
> &
  Partial<{
    受注No?: string
    受注部所: string
    表紙分割?: string
    請求内訳?: string
    付替区分?: string
    車種区分?: string
    運行部所?: string
    配車状態区分?: string
    確認区分?: string
    傭車あり: boolean
    表示順区分: string
    乗務員コード?: string
    備考?: string
    内容?: string
    指定時間?: string
  }>

type T表示用検索条件共通部 = Omit<
  T表示用検索条件<T海コン検索日種別コード>,
  | "積日From"
  | "積日To"
  | "卸日From"
  | "卸日To"
  | "請求計上日From"
  | "請求計上日To"
  | "確認区分"
> & {
  請求額確認区分?: string
}

const KaikonZyutyuHaisyaList = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  const [accordionController, setAccordionController] = useState(true)

  //TODO:ページ名称確定必須
  let gridId = "kaikonZyutyuHaisyaList_GridId"

  //#region [state]

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [作業区分ItemSource, set作業区分ItemSource] = useState<T区分マスタ[]>()

  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<T表示用検索条件<T海コン検索日種別コード>>()

  const [preSearchCondition, setPreSearchCondition] =
    useState<TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>>()

  const [searchResult, setSearchResult] =
    useState<TKaikonZyutyuHaisyaListGetRes[]>()

  //１列目
  const [検索日コード, set検索日コード] = useState<string | null>()
  const [, set検索日] = useState<string | null>()
  const [検索日ItemSource, set検索日ItemSource] =
    useState<T検索日ComboboxItem[]>()
  const [検索日From, set検索日From] = useState<string | null | undefined>(
    翌営業日
  )
  const [検索日To, set検索日To] = useState<string | null | undefined>(翌営業日)

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [付替区分コード, set付替区分コード] = useState<string | null>()
  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [配車状態区分コード, set配車状態区分コード] = useState<string | null>()
  const [受注配車番号, set受注配車番号] = useState("")

  //２列目
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主略称1, set荷主略称1] = useState<string>()

  const [表紙分割id, set表紙分割id] = useState<number | null>()
  const [表紙分割ItemSource, set表紙分割ItemSource] = useState<T表紙分割[]>()

  const [オーダー内容, setオーダー内容] = useState<string>()

  const [車番, set車番] = useState<string>()
  const [車種区分コード, set車種区分コード] = useState<string | null>()

  const [乗務員コード, set乗務員コード] = useState<string>()
  const [乗務員, set乗務員] = useState<string>()
  const [傭車会社あり対象フラグ, set傭車会社あり対象フラグ] = useState(0)

  // ３列目
  const [社名, set社名] = useState<string>()
  const [請求内訳id, set請求内訳id] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()
  const [オーダー備考, setオーダー備考] = useState<string>()
  const [荷主依頼番号, set荷主依頼番号] = useState<string>()
  const [請求額確認区分コード, set請求額確認区分コード] = useState<
    string | null
  >()
  const [表示順区分コード, set表示順区分コード] = useState<string | null>()

  //４列目
  const [地名, set地名] = useState<string>()
  const [コンテナ番号, setコンテナ番号] = useState<string>()
  const [オーダー指定時間, setオーダー指定時間] = useState<string>()

  //その他
  const [isInvalid受注部所コード, setisInvalid受注部所コード] = useState(false)
  const [検索結果受注部所コード, set検索結果受注部所コード] =
    useState<string>("")

  //#endregion

  //#region [comboboxState]
  // 検索日
  const [検索日ComboBox, set検索日ComboBox] = useState<TWijmoComboBox<
    T検索日ComboboxItem["value"],
    T検索日ComboboxItem
  > | null>(null)
  const [検索日IsLoadEnded, set検索日IsLoadEnded] = useState<boolean>(false)

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // 付替区分
  const [付替区分ComboBox, set付替区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [付替区分isLoadEnded, set付替区分isLoadEnded] = useState<boolean>(false)
  // 車種
  const [車種区分ComboBox, set車種区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [車種区分isLoadEnded, set車種区分isLoadEnded] = useState<boolean>(false)
  // 運行場所
  const [運行部所ComboBox, set運行部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [運行部所isLoadEnded, set運行部所isLoadEnded] = useState<boolean>(false)

  // 配車状態
  const [配車状態区分ComboBox, set配車状態区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [配車状態区分isLoadEnded, set配車状態区分isLoadEnded] =
    useState<boolean>(false)
  // 請求額確認
  const [請求額確認区分ComboBox, set請求額確認区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [請求額確認区分isLoadEnded, set請求額確認区分isLoadEnded] =
    useState<boolean>(false)
  // 表示順
  const [表示順区分ComboBox, set表示順区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [表示順区分isLoadEnded, set表示順区分isLoadEnded] =
    useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)
  // 荷主検索用モーダル
  const [is荷主検索Modal, setIs荷主検索Modal] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      setInit荷主請求内訳(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set検索日ItemSource(検索日制御用配列)
      set区分ItemSource(区分マスタRes.data)
      区分マスタRes &&
        set作業区分ItemSource(
          区分マスタRes.data.filter((d) => d.区分コード.match(new RegExp(/2./)))
        )
      setComboBoxDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 受注部所isLoadEnded && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        restoreSearch()
      } else {
        set受注部所コード(userInfo.部所コード)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 受注部所isLoadEnded, comboBoxDataInitialized])

  //#endregion

  //#region [method]

  /**
   * ページ初期状態でクエリに表紙名もしくは荷主請求内訳があった時に一覧を取得します。
   */
  const setInit荷主請求内訳 = async () => {
    if (location.search == null || location.search === "") return

    const query: Partial<
      TKaikonZyutyuHaisyaListGetReq<"1"> &
        TKaikonZyutyuHaisyaListGetReq<"2"> &
        TKaikonZyutyuHaisyaListGetReq<"3"> &
        TKaikonZyutyuHaisyaListGetReq<"4"> &
        TKaikonZyutyuHaisyaListGetReq<"5"> &
        TKaikonZyutyuHaisyaListGetReq<"6">
    > = queryString.parse(location.search)
    if (query == null) return

    // 表紙名と請求内訳からlistを取得し、埋め込む
    if (query.荷主コード) {
      const 表紙分割Res = await new NinusiSeikyuService().getList({
        荷主コード: query.荷主コード,
      })
      if (表紙分割Res.data && 表紙分割Res.data.length > 0) {
        set表紙分割ItemSource([...表紙分割Res.data])
      }
    }
    if (query.表紙分割id) {
      const 荷主請求内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求Id: query.表紙分割id,
      })
      if (荷主請求内訳Res.data && 荷主請求内訳Res.data.length > 0) {
        set請求内訳ItemSource([...荷主請求内訳Res.data])
      }
    }
  }

  const restoreSearch = async () => {
    let querySearchCondition:
      | TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
      | undefined = undefined
    // 遷移してきた際のクエリパラメータで検索条件を生成
    querySearchCondition = await queryParse()
    // 再検索
    search(querySearchCondition).finally(() => {
      dispatch(画面ロック解除())
    })
    // リストア中フラグON
    setIsRestoreSearching(true)
  }

  /**
   * URL Queryを解析
   */
  const queryParse = async () => {
    const query: Partial<
      TKaikonZyutyuHaisyaListGetReq<"1"> &
        TKaikonZyutyuHaisyaListGetReq<"2"> &
        TKaikonZyutyuHaisyaListGetReq<"3"> &
        TKaikonZyutyuHaisyaListGetReq<"4"> &
        TKaikonZyutyuHaisyaListGetReq<"5"> &
        TKaikonZyutyuHaisyaListGetReq<"6">
    > = queryString.parse(location.search)
    set受注部所コード(query.受注部所コード ?? userInfo.部所コード ?? null)
    set荷主コード(query.荷主コード)
    set荷主略称1(query.荷主略称1)
    setオーダー備考(query.オーダー備考)
    setオーダー内容(query.オーダー内容)
    setオーダー指定時間(query.オーダー指定時間)
    setコンテナ番号(query.コンテナ番号)
    set社名(query.ヤード)
    set乗務員コード(query.乗務員コード)
    set乗務員(query.乗務員)
    set付替区分コード(query.付替区分コード)
    set傭車会社あり対象フラグ(query.傭車会社あり対象フラグ ?? 0)
    set荷主依頼番号(query.荷主依頼番号)
    set受注配車番号(
      `${query.受注伝票番号 ?? ""}${query.受注枝番 ? `-${query.受注枝番}` : ""}`
    )

    const query表紙分割ID = query?.表紙分割id?.toString() ?? ("" as string)
    query表紙分割ID !== "" && set表紙分割id(parseInt(query表紙分割ID))
    const query請求内訳ID = query?.請求内訳id?.toString() ?? ("" as string)
    query請求内訳ID !== "" && set請求内訳id(parseInt(query請求内訳ID))

    set車番(query.車番)
    set運行部所コード(query.運行部所コード ?? null)
    if (query.PICK作業日From || query.PICK作業日To) {
      set検索日コード(e海コン検索日種別.PICK作業日)
      set検索日From(query.PICK作業日From)
      set検索日To(query.PICK作業日To)
    } else if (query.作業作業日From || query.作業作業日To) {
      set検索日コード(e海コン検索日種別.作業作業日)
      set検索日From(query.作業作業日From)
      set検索日To(query.作業作業日To)
    } else if (query.返却作業日From || query.返却作業日To) {
      set検索日コード(e海コン検索日種別.返却作業日)
      set検索日From(query.返却作業日From)
      set検索日To(query.返却作業日To)
    } else if (query.その他作業日From || query.その他作業日To) {
      set検索日コード(e海コン検索日種別.その他作業日)
      set検索日From(query.その他作業日From)
      set検索日To(query.その他作業日To)
    } else if (query.請求計上日From || query.請求計上日To) {
      set検索日コード(e海コン検索日種別.請求計上日)
      set検索日From(query.請求計上日From)
      set検索日To(query.請求計上日To)
    } else if (query.検索日From || query.検索日To) {
      set検索日コード(e海コン検索日種別.PICK作業返却その他)
      set検索日From(query.検索日From)
      set検索日To(query.検索日To)
    }
    set表示順区分コード(query.表示順区分コード)
    return query as TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
  }

  /**
   * 検索
   */
  const search = async (
    searchCondition?: TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
  ) => {
    //遷移の制御確認
    if (isPrompt.current) {
      if (window.confirm(CONSTANT.MESSAGES.BROWSER_BACK)) {
        isPrompt.current = false
      } else {
        return
      }
    }
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition:
      | TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
      | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    // TODO:検索処理導入
    try {
      const service = new KaikonZyutyuHaisyaService()

      const res = await service.getList(currentSearchCondition)

      // QueryStringに検索条件を反映
      pageHelper.pushQuery(history, location, currentSearchCondition)

      setSearchResult([...res.data])
      setPreSearchCondition(currentSearchCondition)
      set検索結果受注部所コード(currentSearchCondition.受注部所コード ?? "")
      // QueryStringに検索条件を反映
      pageHelper.pushQuery(history, location, currentSearchCondition)
    } catch (error) {
      dispatch(setAlerts(error))
      setIsSearching(false)
    } finally {
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード> | undefined => {
    // 受注配車番号を受注伝票番号と受注枝番に変換
    const [受注伝票番号, 受注枝番] = 受注配車番号.split("-")

    let 共通検索条件: TKaikonZyutyuHaisyaListGetReqInner = {
      受注伝票番号,
      受注枝番,
      オーダー備考,
      オーダー内容,
      オーダー指定時間,
      荷主コード,
      荷主略称1: 荷主略称1,
      表紙分割id:
        表紙分割id != null && 表紙分割id !== 0 ? 表紙分割id : undefined,
      請求内訳id:
        請求内訳id != null && 請求内訳id !== 0 ? 請求内訳id : undefined,
      コンテナ番号: コンテナ番号,
      // 品名,
      受注部所コード: 受注部所コード ?? "",
      荷主依頼番号,
      // 積地社名,
      // 積地地名,
      社名,
      地名,
      付替区分コード: 付替区分コード ?? undefined,
      車番,
      車種区分コード: 車種区分コード ?? undefined,
      乗務員コード,
      乗務員,
      運行部所コード: 運行部所コード ?? undefined,
      請求額確認区分コード: 請求額確認区分コード ?? undefined,
      傭車会社あり対象フラグ,
      表示順区分コード: 表示順区分コード ?? undefined,
    }
    switch (検索日コード) {
      case e海コン検索日種別.PICK作業日:
        let 検索条件1: TKaikonZyutyuHaisyaListGetReq<"1"> = {
          ...共通検索条件,
          PICK作業日From: 検索日From ?? "",
          PICK作業日To: 検索日To ?? "",
        }
        return 検索条件1
      case e海コン検索日種別.作業作業日:
        let 検索条件2: TKaikonZyutyuHaisyaListGetReq<"2"> = {
          ...共通検索条件,
          作業作業日From: 検索日From ?? "",
          作業作業日To: 検索日To ?? "",
        }
        return 検索条件2
      case e海コン検索日種別.返却作業日:
        let 検索条件3: TKaikonZyutyuHaisyaListGetReq<"3"> = {
          ...共通検索条件,
          返却作業日From: 検索日From ?? "",
          返却作業日To: 検索日To ?? "",
        }
        return 検索条件3
      case e海コン検索日種別.その他作業日:
        let 検索条件4: TKaikonZyutyuHaisyaListGetReq<"4"> = {
          ...共通検索条件,
          その他作業日From: 検索日From ?? "",
          その他作業日To: 検索日To ?? "",
        }
        return 検索条件4
      case e海コン検索日種別.請求計上日:
        let 検索条件5: TKaikonZyutyuHaisyaListGetReq<"5"> = {
          ...共通検索条件,
          請求計上日From: 検索日From ?? "",
          請求計上日To: 検索日To ?? "",
        }
        return 検索条件5
      case e海コン検索日種別.PICK作業返却その他:
        let 検索条件6: TKaikonZyutyuHaisyaListGetReq<"6"> = {
          ...共通検索条件,
          検索日From: 検索日From ?? "",
          検索日To: 検索日To ?? "",
        }
        return 検索条件6
      default:
        break
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
  ): T表示用検索条件<T海コン検索日種別コード> | undefined => {
    let 表示用検索条件共通部: T表示用検索条件共通部 = {
      受注No: searchCondition.受注伝票番号
        ? `${searchCondition.受注伝票番号}${
            searchCondition.受注枝番 ? `-${searchCondition.受注枝番}` : ""
          }`
        : undefined,
      備考: searchCondition.オーダー備考,
      内容: searchCondition.オーダー内容,
      指定時間: searchCondition.オーダー指定時間,
      荷主コード: searchCondition.荷主コード,
      荷主名: searchCondition.荷主略称1,
      表紙分割: 表紙分割ItemSource?.find(
        (i) =>
          i.荷主請求ID.toString() === searchCondition?.表紙分割id?.toString()
      )?.表紙名,
      請求内訳: 請求内訳ItemSource?.find(
        (i) =>
          i.荷主請求内訳ID.toString() ===
          searchCondition?.請求内訳id?.toString()
      )?.請求内訳名,
      // 品名: searchCondition.品名,
      コンテナ番号: searchCondition.コンテナ番号,
      受注部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.受注部所コード
      )?.部所名,
      荷主依頼番号: searchCondition.荷主依頼番号,
      社名: searchCondition.社名,
      地名: searchCondition.地名,
      付替区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.付替区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.付替区分
      )?.名称1,
      車番: searchCondition.車番,
      車種区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.車種区分コード &&
          i.分類コード === 区分分類コード.車輌.車種区分
      )?.名称1,
      乗務員コード: 乗務員コード,
      乗務員: searchCondition.乗務員,
      運行部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.運行部所コード
      )?.部所名,

      請求額確認区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.請求額確認区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
      )?.名称1,
      傭車あり: searchCondition.傭車会社あり対象フラグ === 1,
      表示順区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.表示順区分コード &&
          i.分類コード ===
            区分分類コード.受注配車_請求支払.海コン受注配車入力表示順区分
      )?.名称1,
    }
    switch (検索日コード) {
      case e海コン検索日種別.PICK作業日:
        let 検索条件1: T表示用検索条件<"1"> = {
          PICK作業日From: dateUtil.format(検索日From) ?? "",
          PICK作業日To: dateUtil.format(検索日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件1

      case e海コン検索日種別.作業作業日:
        let 検索条件2: T表示用検索条件<"2"> = {
          作業作業日From: dateUtil.format(検索日From) ?? "",
          作業作業日To: dateUtil.format(検索日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件2

      case e海コン検索日種別.返却作業日:
        let 検索条件3: T表示用検索条件<"3"> = {
          返却作業日From: dateUtil.format(検索日From) ?? "",
          返却作業日To: dateUtil.format(検索日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件3

      case e海コン検索日種別.その他作業日:
        let 検索条件4: T表示用検索条件<"4"> = {
          その他作業日From: dateUtil.format(検索日From) ?? "",
          その他作業日To: dateUtil.format(検索日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件4

      case e海コン検索日種別.請求計上日:
        let 検索条件5: T表示用検索条件<"5"> = {
          請求計上日From: dateUtil.format(検索日From) ?? "",
          請求計上日To: dateUtil.format(検索日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件5
      case e海コン検索日種別.PICK作業返却その他:
        let 検索条件6: T表示用検索条件<"6"> = {
          検索日From: dateUtil.format(検索日From) ?? "",
          検索日To: dateUtil.format(検索日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件6
      default:
        break
    }
  }

  /**
   * 荷主コード入力後の反応
   * @param 荷主コード
   * @returns
   */
  const set表紙 = async (荷主コード: string) => {
    try {
      if (荷主コード == null || 荷主コード === "") {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主res = await new NinusiService().getList({
        荷主コード: 荷主コード !== "" ? 荷主コード : undefined,
        完全一致フラグ: true,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主 = 荷主res.data[0]
      set荷主コード(荷主.荷主コード)
      set荷主略称1(荷主.荷主略称1)
      if (荷主 != null) {
        const ninusiSeikyuService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiSeikyuService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res && 荷主請求res.data.length > 0) {
          set表紙分割ItemSource([...荷主請求res.data])
          set請求内訳ItemSource([])
        } else {
          set表紙分割ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }
  //#endregion
  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">海コン受注配車一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-150rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body id="collapse-search-card-body">
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-10rem">
                                <ComboBox.Default
                                  placeholder="検索日"
                                  itemsSource={検索日ItemSource}
                                  isLoadEnded={検索日IsLoadEnded}
                                  selectedValue={検索日コード}
                                  isRequired={true}
                                  setSelectedValue={(v) => {
                                    set検索日コード(v)
                                  }}
                                  setText={set検索日}
                                  setIsLoadEnded={set検索日IsLoadEnded}
                                  ComboBox={検索日ComboBox}
                                  setComboBox={
                                    set検索日ComboBox
                                  }></ComboBox.Default>
                              </div>
                              <div className="w-13rem">
                                <DateInput
                                  id="検索日from"
                                  placeholder="検索日From"
                                  isRequired={true}
                                  has1DayButton={true}
                                  value={検索日From}
                                  defaultValue={翌営業日}
                                  setValue={(v) => {
                                    set検索日From(v)
                                  }}></DateInput>
                              </div>
                              <div className="w-13rem">
                                <DateInput
                                  id="検索日To"
                                  placeholder="検索日To"
                                  value={検索日To}
                                  isRequired={true}
                                  has1DayButton={true}
                                  defaultValue={翌営業日}
                                  setValue={(v) => {
                                    set検索日To(v)
                                  }}></DateInput>
                              </div>
                              <div className=""></div>
                              <ComboBox.Busyo
                                placeholder="受注部所"
                                className={
                                  isInvalid受注部所コード
                                    ? "busyo-combo-box is-error"
                                    : "busyo-combo-box"
                                }
                                isLoadEnded={受注部所isLoadEnded}
                                setIsLoadEnded={set受注部所isLoadEnded}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                isAllSelect={false}
                                isEmpty={true}
                                isRequired={true}
                                itemsSource={部所ItemSource}
                                selectedValue={受注部所コード}
                                setSelectedValue={(v) => {
                                  set受注部所コード(v)
                                }}
                                ComboBox={受注部所ComboBox}
                                setComboBox={
                                  set受注部所ComboBox
                                }></ComboBox.Busyo>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="付替区分"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払.付替区分
                                  }
                                  isAllSelect={true}
                                  isRequired={false}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={付替区分isLoadEnded}
                                  setIsLoadEnded={set付替区分isLoadEnded}
                                  selectedValue={付替区分コード}
                                  setSelectedValue={(v) => {
                                    set付替区分コード(v)
                                  }}
                                  ComboBox={付替区分ComboBox}
                                  setComboBox={
                                    set付替区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <ComboBox.Busyo
                                placeholder="運行部所"
                                isLoadEnded={運行部所isLoadEnded}
                                setIsLoadEnded={set運行部所isLoadEnded}
                                isAllSelect={true}
                                isRequired={false}
                                itemsSource={部所ItemSource}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                selectedValue={運行部所コード}
                                setSelectedValue={(v) => {
                                  set運行部所コード(v)
                                }}
                                ComboBox={運行部所ComboBox}
                                setComboBox={
                                  set運行部所ComboBox
                                }></ComboBox.Busyo>

                              <ComboBox.Kubun
                                placeholder="配車状態"
                                分類コード={
                                  区分分類コード.受注配車_請求支払.配車状態区分
                                }
                                itemsSource={作業区分ItemSource}
                                isLoadEnded={配車状態区分isLoadEnded}
                                setIsLoadEnded={set配車状態区分isLoadEnded}
                                isAllSelect={true}
                                isRequired={false}
                                selectedValue={配車状態区分コード}
                                setSelectedValue={(v) => {
                                  set配車状態区分コード(v)
                                }}
                                ComboBox={配車状態区分ComboBox}
                                setComboBox={
                                  set配車状態区分ComboBox
                                }></ComboBox.Kubun>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "12rem" }}
                                  id="受注No"
                                  name="受注No"
                                  value={受注配車番号}
                                  setValue={(v) => {
                                    set受注配車番号(v)
                                  }}
                                  placeholder="受注No"
                                />
                              </div>
                            </div>
                            <div className="search-condition-row">
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "6rem" }}
                                  id="荷主コード"
                                  name="荷主コード"
                                  value={荷主コード}
                                  onBlur={async (e) => {
                                    const v = e.currentTarget.value
                                    set表紙(v)
                                  }}
                                  setValue={(v) => {
                                    set荷主コード(v)
                                  }}
                                  maxLength={5}
                                  placeholder="荷主CD"
                                />
                                <button
                                  type="button"
                                  className="icon-button"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setIs荷主検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon
                                    className="icon-button-inner"
                                    icon={faSearch}></FontAwesomeIcon>
                                </button>
                                <TextInput
                                  id="荷主名"
                                  style={{ width: "14.5rem" }}
                                  name="荷主名"
                                  value={荷主略称1}
                                  setValue={set荷主略称1}
                                  maxLength={100}
                                  placeholder="荷主略称"
                                />
                              </div>
                              <ComboBox.HyosiBunkatu
                                placeholder="表紙名"
                                isReadOnly={
                                  表紙分割ItemSource == null ||
                                  表紙分割ItemSource.length <= 0
                                    ? true
                                    : false
                                }
                                isAllSelect={true}
                                itemsSource={表紙分割ItemSource}
                                isLoadEnded={表紙分割IsLoadEnded}
                                setIsLoadEnded={set表紙分割IsLoadEnded}
                                lostFocus={(control) => {
                                  if (control.selectedValue == null) return
                                  const ninusiSeikyuService =
                                    new NinusiSeikyuService()
                                  ninusiSeikyuService
                                    .getListUchiwake({
                                      荷主請求Id: control.selectedValue,
                                    })
                                    .then((res) => {
                                      res.data &&
                                        set請求内訳ItemSource([...res.data])
                                    })
                                }}
                                setSelectedValue={(v) => {
                                  set表紙分割id(v)
                                }}
                                selectedValue={表紙分割id}
                                ComboBox={表紙分割ComboBox}
                                setComboBox={
                                  set表紙分割ComboBox
                                }></ComboBox.HyosiBunkatu>
                              <TextInput
                                id="オーダー内容"
                                name="オーダー内容"
                                value={オーダー内容}
                                setValue={(v) => {
                                  setオーダー内容(v)
                                }}
                                placeholder="内容"
                              />
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "5rem" }}
                                  id="車番"
                                  name="車番"
                                  value={車番}
                                  setValue={set車番}
                                  maxLength={4}
                                  placeholder="車番"
                                />
                                <ComboBox.Kubun
                                  placeholder="車種区分"
                                  分類コード={区分分類コード.車輌.車種区分}
                                  isAllSelect={true}
                                  isRequired={false}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={車種区分isLoadEnded}
                                  setIsLoadEnded={set車種区分isLoadEnded}
                                  selectedValue={車種区分コード}
                                  setSelectedValue={(v) => {
                                    set車種区分コード(v)
                                  }}
                                  ComboBox={車種区分ComboBox}
                                  setComboBox={
                                    set車種区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "5rem" }}
                                  id="乗務員コード"
                                  name="乗務員コード"
                                  value={乗務員コード}
                                  setValue={set乗務員コード}
                                  maxLength={4}
                                  placeholder="社員CD"
                                />
                                <TextInput
                                  id="乗務員"
                                  name="乗務員"
                                  value={乗務員}
                                  setValue={set乗務員}
                                  maxLength={100}
                                  placeholder="乗務員"
                                />
                              </div>
                              <span className={"align-middle"}>
                                <CheckInput
                                  id="傭車"
                                  type={"switch"}
                                  label={"傭車"}
                                  setValue={(v) => set傭車会社あり対象フラグ(v)}
                                  value={傭車会社あり対象フラグ}
                                />
                              </span>
                            </div>
                            <div className="search-condition-row">
                              <TextInput
                                style={{ width: "22.5rem" }}
                                id="社名"
                                name="社名"
                                value={社名}
                                setValue={set社名}
                                maxLength={100}
                                placeholder="社名・ヤード"
                              />
                              <ComboBox.SeikyuUtiwake
                                placeholder="請求内訳"
                                isReadOnly={
                                  請求内訳ItemSource == null ||
                                  請求内訳ItemSource.length <= 0
                                    ? true
                                    : false
                                }
                                isAllSelect={true}
                                itemsSource={請求内訳ItemSource}
                                isLoadEnded={請求内訳IsLoadEnded}
                                setIsLoadEnded={set請求内訳IsLoadEnded}
                                setSelectedValue={(v) => {
                                  set請求内訳id(v)
                                }}
                                selectedValue={請求内訳id}
                                ComboBox={請求内訳ComboBox}
                                setComboBox={
                                  set請求内訳ComboBox
                                }></ComboBox.SeikyuUtiwake>
                              <TextInput
                                id="オーダー備考"
                                name="オーダー備考"
                                value={オーダー備考}
                                setValue={(v) => {
                                  setオーダー備考(v)
                                }}
                                placeholder="備考"
                              />
                              <div className="w-12rem">
                                <TextInput
                                  id="荷主依頼No"
                                  name="荷主依頼No"
                                  value={荷主依頼番号}
                                  setValue={set荷主依頼番号}
                                  maxLength={100}
                                  placeholder="荷主依頼No"
                                />
                              </div>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="請求額確認"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .請求支払確認区分
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={請求額確認区分isLoadEnded}
                                  isAllSelect={true}
                                  isRequired={false}
                                  setIsLoadEnded={set請求額確認区分isLoadEnded}
                                  selectedValue={請求額確認区分コード}
                                  setSelectedValue={(v) => {
                                    set請求額確認区分コード(v)
                                  }}
                                  ComboBox={請求額確認区分ComboBox}
                                  setComboBox={
                                    set請求額確認区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <ComboBox.Kubun
                                placeholder="表示順"
                                分類コード={
                                  区分分類コード.受注配車_請求支払
                                    .海コン受注配車入力表示順区分
                                }
                                itemsSource={区分ItemSource}
                                isLoadEnded={表示順区分isLoadEnded}
                                isAllSelect={false}
                                isRequired={false}
                                setIsLoadEnded={set表示順区分isLoadEnded}
                                selectedValue={表示順区分コード}
                                setSelectedValue={(v) => {
                                  set表示順区分コード(v)
                                }}
                                ComboBox={表示順区分ComboBox}
                                setComboBox={
                                  set表示順区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                            <div className="search-condition-row">
                              <TextInput
                                style={{ width: "22.5rem" }}
                                id="地名"
                                name="地名"
                                value={地名}
                                setValue={set地名}
                                maxLength={100}
                                placeholder="地名"
                              />
                              <TextInput
                                style={{ width: "19rem" }}
                                id="コンテナ番号"
                                name="コンテナ番号"
                                value={コンテナ番号}
                                setValue={(v) => {
                                  setコンテナ番号(v)
                                }}
                                maxLength={11}
                                placeholder="コンテナ番号"
                              />
                              <TextInput
                                id="オーダー指定時間"
                                name="オーダー指定時間"
                                value={オーダー指定時間}
                                setValue={(v) => {
                                  setオーダー指定時間(v)
                                }}
                                placeholder="指定時間"
                              />
                            </div>
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                // 受注部所、未選択の場合検索させない
                                if (
                                  受注部所コード == null ||
                                  受注部所コード === ""
                                ) {
                                  setisInvalid受注部所コード(true)
                                  dispatch(
                                    setWarningAlerts([
                                      "受注部所を選択してください",
                                    ])
                                  )
                                  return
                                }
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col xs={12}>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <KaikonZyutyuHaisyaListProvider
                  isSearching={{ state: isSearching, setState: setIsSearching }}
                  isRestoreSearching={{
                    state: isRestoreSearching,
                    setState: setIsRestoreSearching,
                  }}
                  SearchResult={searchResult}
                  gridInitialized={{
                    state: gridInitialized,
                    setState: setGridInitialized,
                  }}
                  searchCondition={preSearchCondition}
                  search={search}
                  受注部所コード={検索結果受注部所コード}
                  isPrompt={isPrompt}>
                  <KaikonZyutyuHaisyaListGrid
                    gridId={gridId}></KaikonZyutyuHaisyaListGrid>
                </KaikonZyutyuHaisyaListProvider>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set表紙(荷主.荷主コード)
        }}></NinusiSearchModal>
    </>
  )
}

export default KaikonZyutyuHaisyaList
